<template>
  <div>
    redirecting
  </div>
</template>

<script>
export default {
  mounted() {
    if (sessionStorage.getItem('sessionTimeOut')) {
      this.isSessionTimeOut = true
    } else {
      this.isSessionTimeOut = false
    }
    sessionStorage.clear()

    this.$auth.loginWithRedirect()
  }
}
</script>

<style lang="scss" scoped></style>
